const DevicePicker = ({ device, setDevice, marginTop = "17px" }) => {
  return (
    <div style={{ display: "flex", marginTop: marginTop }}>
      <button
        className={`vhc funnel-filter-toggle-btn-${
          device === "phone" ? "active" : "inactive"
        }`}
        onClick={() => setDevice("phone")}
      >
        <i className="fa-regular fa-mobile fs-20"></i>
      </button>
      <button
        className={`vhc funnel-filter-toggle-btn-${
          device === "desktop" ? "active" : "inactive"
        }`}
        onClick={() => setDevice("desktop")}
      >
        <i className="fa-regular fa-laptop fs-20"></i>
      </button>
      <button
        className={`vhc funnel-filter-toggle-btn-${
          device === "tablet" ? "active" : "inactive"
        }`}
        onClick={() => setDevice("tablet")}
      >
        <i className="fa-regular fa-tablet fs-20"></i>
      </button>
    </div>
  );
};

export default DevicePicker;
